import React from 'react';
import { ArrowLeft, RotateCcw, Users } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { FORMAT_ICONS } from './iconMap';

const SummaryBar = ({ format, participantType, participantCount, onEdit, onReset, readOnly = false }) => {
  const { theme } = useTheme();
  const Icon = FORMAT_ICONS[format.icon];

  return (
    <div className={`tf-animate-in flex flex-wrap items-center justify-between gap-3 rounded-2xl border ${theme.border} ${theme.backgroundSecondary} px-4 py-3`}>
      <div className="flex items-center gap-3">
        <span className={`flex h-9 w-9 items-center justify-center rounded-lg ${theme.buttonPrimary}`}>
          {Icon && <Icon size={17} />}
        </span>
        <div>
          <div className={`text-sm font-semibold ${theme.text}`}>{format.label}</div>
          <div className={`flex items-center gap-1 text-xs ${theme.textMuted}`}>
            <Users size={12} />
            {/* 'teams' always reads as just "N teams" — format.participantLabel
                ('participants' for round_robin, 'teams' for cross_group) would
                either duplicate the word or hide that they're teams at all. */}
            {participantCount} {participantType === 'teams' ? 'teams' : `${participantType} ${format.participantLabel}`}
          </div>
        </div>
      </div>
      {/* Editing the format/participants no longer makes sense once the
          tournament itself has started or finished — hidden rather than
          disabled, matching how the rest of the editing toolbar behaves in
          GeneratedScheduleStep.jsx once locked. */}
      {!readOnly && (
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={onEdit}
            className={`flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-medium transition-colors ${theme.buttonGhost}`}
          >
            <ArrowLeft size={13} />
            Back
          </button>
          <button
            type="button"
            onClick={onReset}
            className={`flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-medium transition-colors ${theme.buttonGhost}`}
          >
            <RotateCcw size={13} />
            Start over
          </button>
        </div>
      )}
    </div>
  );
};

export default SummaryBar;
